var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChattag = function SvgChattag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#556575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.617 12.316a1.2 1.2 0 0 1-1.698.001L2.349 9.75a1.2 1.2 0 0 1 0-1.698l4.333-4.33c.25-.25.589-.39.943-.39H10c.737 0 1.334.597 1.334 1.333V7.04c0 .353-.14.692-.39.942z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#556575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.003 5.332v2.533c0 .354-.14.693-.39.943l-3.777 3.777"
  })));
};
export { SvgChattag as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZTliMzA0ZTIwYjVhZjk4YTVhNWYyMjhlNzk0MjFmNzQuc3ZnIjs=";